import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/card-member.png'


const _hoisted_1 = { class: "md:w-[500px] max-w-[500px] overflow-hidden bg-white border rounded-md shadow-md pb-[50px]" }
const _hoisted_2 = { class: "flex justify-end p-4" }
const _hoisted_3 = {
  id: "printableArea",
  class: "mt-5 flex justify-center"
}
const _hoisted_4 = { class: "relative w-[300px] h-[500px]" }
const _hoisted_5 = { class: "absolute inset-0 flex flex-col items-center justify-center text-white mt-[-30px]" }
const _hoisted_6 = { class: "w-[190px] h-[190px] rounded-full overflow-hidden bg-white mb-[40px]" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-col items-center gap-4" }
const _hoisted_9 = {
  class: "text-xl !text-[#ffff] font-semibold whitespace-pre-line",
  style: {"word-wrap":"break-word"}
}
const _hoisted_10 = { class: "text-lg !text-[#ffff]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "fixed z-[998] bg-black top-0 right-0 w-full h-screen opacity-[0.4]" }, null, -1)),
    _createElementVNode("div", {
      class: "fixed z-[999] flex justify-center items-center w-screen h-screen top-0 right-0",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, [
      _createElementVNode("div", {
        ref: "modalContent",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printCard && _ctx.printCard(...args))),
              class: "px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none"
            }, " Print ")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Card Background",
                class: "absolute inset-0 w-full h-full object-cover"
              }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.data?.picture || '/placeholder.png',
                    alt: "Profile Picture",
                    class: "w-full h-full object-cover"
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.data?.parentName || 'Nama Orang Tua'), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.data?.code || 'NIM Anak'), 1)
                ])
              ])
            ])
          ])
        ])
      ], 512)
    ])
  ], 64))
}